<template>
  <div>
    <hr>
    <div class="m-3 text-muted">
      <b-form-checkbox plain inline
        :checked="showAllFields"
        @input="$store.commit('preferences/setPreference', {showAllFields: $event})"
      ><small>Show read-only fields</small></b-form-checkbox>
      <b-form-checkbox plain inline
        :checked="showRaw"
        @input="$store.commit('preferences/setPreference', {showRaw: $event})"
      ><small>Raw</small></b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ShowFields',
  computed: {
    ...mapState('preferences', [
      'showAllFields',
      'showRaw',
    ]),
  },
}
</script>
